import { RcFile } from "antd/lib/upload";
import CryptoJS from "crypto-js";
import { debounce } from "lodash";
import { CONSTANT,SALT } from "./Constant";
import moment from "moment";
import { notification } from "antd";
import store from "../store/app";
import { resetAuthStore } from "../store/AuthSlice";
import { error } from "console";

export const Constant = {
  API_KEY: "secret-api-key",
};

export const handleStorageEvents = (e: any) => {
  if (e.key === "token") {
    if (e.oldValue && !e.newValue) {
      window.location.href = "/";
      store.dispatch(resetAuthStore());
    } else if (!e.oldValue && e.newValue) {
      window.location.reload();
    }
  }
  if (e.key === "initialData") {
    if (e.oldValue !== e.newValue) {
      window.location.reload();
    }
  }
};

export const uploadedFileOnPreview = async (file: any) => {
  let src = file.url as string;
  if (!src) {
    src = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj as RcFile);
      reader.onload = () => resolve(reader.result as string);
    });
  }

  const image = new Image();
  image.src = src;
  const imgWindow: any = window.open(src);
  imgWindow.document.write(image.outerHTML);
};

const insertAt = (array: any[], index: number, ...elementsArray: any[]) => {
  array.splice(index, 0, ...elementsArray);
};

export const convertTextToID = (
  textArray: any,
  mainArray: any,
  textKey = "name",
  idKey = "id"
) => {
  const newArray: any = [];
  if (textArray && textArray.values && textArray.values.length > 0) {
    textArray.values.forEach((x: any) => {
      const temp = mainArray.find((y: any) => y[textKey] === x);
      if (x && temp) {
        newArray.push(temp[idKey]);
      } else {
        insertAt(newArray, 0, x);
      }
    });
  }

  return newArray;
};

export const copyTextToClipboard = (textToCopy: any) => {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method'
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise<void>((res, rej) => {
      // here the magic happens
      document.execCommand("copy") ? res() : rej();
      textArea.remove();
    });
  }
};

export const stringEncryption = (string: string) => {
  return CryptoJS.AES.encrypt(string, Constant.API_KEY)
    .toString()
    .replace(/\+/g, "xMl3Jk")
    .replace(/\//g, "Por21Ld")
    .replace(/=/g, "Ml32");
};

export const stringDecryption = (string: string) => {
  string = string
    .replace(/xMl3Jk/g, "+")
    .replace(/Por21Ld/g, "/")
    .replace(/Ml32/g, "=");
  return CryptoJS.AES.decrypt(string, Constant.API_KEY).toString(
    CryptoJS.enc.Utf8
  );
};

export const dataToFormDataConverter = (data: any) => {
  const formData = new FormData();
  for (let name in data) {
    const value = data[name];

    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        name = `${name}[]`;
        value.map((item) => {
          formData.append(name, item);
          return item;
        });
      } else {
        formData.append(name, value);
      }
    }
    // formData.append(name, data[name]); // there should be values.avatar which is a File object
  }
  return formData;
};

export const b64toBlob = (b64Data: any, contentType: any, sliceSize: any) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

// For validate the form fields
export const validateFields = debounce((form, setDisabled) => {
  form
    .validateFields()
    .then(() => {
      setDisabled(false);
    })
    .catch(() => {
      setDisabled(true);
    });
}, 500);

export const dateFormatter = (
  date: any,
  format = CONSTANT.DATE_TIME_FORMAT
) => {
  return moment.utc(date).local().format(format);
};

export const snakeCaseString = (str: any): string => {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((s: any) => s.toLowerCase())
      .join("_")
  );
};

export const camelCaseString = (str: string): string => {
  str = str
    .replace(/[-_]+/g, " ")
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word: any, index: any) {
      return index !== 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/ (.)/g, function ($1: any) {
      return $1.toUpperCase();
    });
  return str;
};

/**
 * We use notification from here 3 type of nofiifcation
 * Success: {placement:"bottomRight",message: "Your Success message"}
 * Error: {placement:"bottomRight",message: "Your Error Message"}
 * Info: {placement:"top",message: "Your Info Message"}
 */
export const Notification = {
  success: (data: any) => {
    notification.success({
      placement: data.placement ? data.placement : "bottomRight",
      duration: 3,
      ...data,
    });
  },
  error: (data: any) => {
    notification.error({
      placement: data.placement ? data.placement : "bottomRight",
      duration: 3,
      ...data,
    });
  },
  info: (data?: any) => {
    notification.info({
      placement: data.placement ? data.placement : "top",
      duration: data.duration ? data.duration : 3,
      ...data,
    });
  },
};

//  Checks if the user has the specified permission.
export const checkPrivileges = (
  userDetail: any,
  permissionType: string
): boolean =>
  !!(
    userDetail?.userPrivileges &&
    userDetail?.userPrivileges.includes(permissionType)
  );

// to prevent user from typing in special characters in input fields for numeric values 
export const numericField = (e?: any) =>
  ["e"].includes(e.key) && e.preventDefault();



// to compare two dates
export const dateCompare = (
  startDate: any,
  endDate: any = "",
  format = CONSTANT.DATE_FORMAT
) => {
  var momentA = moment(startDate);
  var momentB = moment();
  if (endDate != '') {
    momentB = moment(endDate);
  }
  if (momentA > momentB) return 1;
  else if (momentA < momentB) return -1;
  else return 0;
};


// encode_decode_base64
export const base64EncodeDecode = (
  type:any = 'encode',
  string: string,
  salt:any = SALT
) => {
  try{

    if(type=='encode')
      {
        // const words = CryptoJS.enc.Utf8.parse(string+'salt'); // WordArray object
        const words = CryptoJS.enc.Utf8.parse(string+salt); // WordArray object
        return {status:true,data:CryptoJS.enc.Base64.stringify(words)};
      }
      else
      {
        const words = CryptoJS.enc.Base64.parse(string);
        // return {status:true,data:CryptoJS.enc.Utf8.stringify(words)};
        return {status:true,data:CryptoJS.enc.Utf8.stringify(words).replaceAll(salt,'')};
      }
    }
    catch(err:any)
    {
      console.error(err);
      return {status:false,data:'',error:err.message};
    }
};



export const downloadBlobFile = (content:any, filename:string, contentType:string) =>{
  // Create a blob
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
}


export const SvgToBase64 = (svgElement: SVGSVGElement) => {
  const serializer = new XMLSerializer();
  let svgString = serializer.serializeToString(svgElement);

  // Ensure the SVG has the xmlns attribute
  if (!svgString.includes('xmlns="http://www.w3.org/2000/svg"')) {
    svgString = svgString.replace(
      /^<svg/,
      '<svg xmlns="http://www.w3.org/2000/svg"'
    );
  }

  // Encode SVG string into Base64 (safe for UTF-8)
  const encoded = btoa(
    encodeURIComponent(svgString).replace(
      /%([0-9A-F]{2})/g,
      (_, p1) => String.fromCharCode(parseInt(p1, 16))
    )
  );

  return `data:image/svg+xml;base64,${encoded}`;
}






